export const GET_USER_SETTING = 'GET_USER_SETTING';
export const GET_USER_TICKET_FILTER = 'GET_USER_TICKET_FILTER';
export const UPDATE_TABLE_FILTER = 'UPDATE_TABLE_FILTER';
export const STORE_USER_TICKET_FILTER = 'STORE_USER_TICKET_FILTER'
export const STORE_USER_SETTING = 'STORE_USER_SETTING';
export const SAVE_USER_SETTING = 'SAVE_USER_SETTING';
export const GET_SHIPMENT_SETTINGS = 'GET_SHIPMENT_SETTINGS';
export const STORE_SHIPMENT_SETTINGS = 'STORE_SHIPMENT_SETTINGS';

